import config from "../config/app.conf.json";

export default uid => ({
  url: `${config.api.organizations_url}/organizations?userId=${uid}`,
  method: "GET"
});
